import { render, staticRenderFns } from "./SchoolCurriculum.vue?vue&type=template&id=0490b3fd&scoped=true&lang=pug&"
import script from "./SchoolCurriculum.vue?vue&type=script&lang=ts&"
export * from "./SchoolCurriculum.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolCurriculum.vue?vue&type=style&index=0&id=0490b3fd&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490b3fd",
  null
  
)

export default component.exports